export default "__VITE_ASSET__CyLR_Os3__"